export default "__VITE_ASSET__Cg$mQRH8__"